import FlyerSection from './FlyerSection'
import FlyerCaptions from './FlyerCaptions'

const FlyerPreview = ({
    maxHeightRef, 
    currentHeightRef, 
    onLoadImg,
    styles, 
    side, 
    section, 
    movies, 
    performances,
    currentCinemaId,
    cinemaData, 
    flyerData, 
    captionAttributes,
    translation,
    colors, 
    iconsColor,
    hasFylerCaption,
    currentPeriodeStartDate, 
    flyerServerData,
    currentPeriodeEndDate, 
    formartedCurrentPeriodeStartDate, 
    formartedCurrentPeriodeEndDate, 
    items, 
    week, 
    logoData
}) => (
    <div className={"flyer-preview-wrapper " + section + ' ' + colors.theme_colors.toLowerCase()} style={styles} ref={maxHeightRef}>
        <div className={`flyer-preview ${side} ${section} ${colors.chosen_font}`}ref={currentHeightRef}> 
            <FlyerSection 
                movies={movies}
                flyerData={flyerData}
                currentCinemaId={currentCinemaId}
                performances={performances}
                cinemaData={cinemaData}
                translation={translation}
                flyerServerData={flyerServerData}
                colors={colors}
                iconsColor={iconsColor}
                currentPeriodeStartDate={currentPeriodeStartDate}
                currentPeriodeEndDate={currentPeriodeEndDate}
                formartedCurrentPeriodeStartDate={formartedCurrentPeriodeStartDate}
                formartedCurrentPeriodeEndDate={formartedCurrentPeriodeEndDate}
                items={items}
                week={week}
                side={side}
                section={section}
                logoData={logoData}
                onLoadImg={onLoadImg}
            />

            {'inside' === side && hasFylerCaption && <FlyerCaptions
                iconsColor={iconsColor}
                translation={translation}
                captionAttributes={captionAttributes}
            />}
        </div>
        <div className='overflow-bar' style={styles}></div>
    </div>
)

export default FlyerPreview